(function($) {
  "use strict";

  jQuery(document).ready(function(){

    
/*---------------------------------
     Mean Menu Active
-----------------------------------*/
jQuery('.header-menu nav').meanmenu({
    meanMenuContainer: '.mobile-menu',
    meanScreenWidth: "991"
})
/*---------------------------------
	 Header Search Toggle Active 
-----------------------------------*/
$( '.search-box > a' ).on('click', function(e) {
    e.preventDefault();
    if($(this).hasClass('active')) {
        $(this).removeClass('active').siblings('.search-dropdown').slideUp();
    } else {
        $(this).addClass('active').siblings('.search-dropdown').slideDown();
    }
});
/*----------------------------
    ** Owl Active **
------------------------------ */
    

    // Section with Editor
    $(document).on('shopify:section:load', function(e){ 
      $('#' + e.target.id).find('[data-section]').sectionJs();
    }).ready(function() {
      $('[data-section]').each(function(){ $(this).sectionJs() });
    });

    $.fn.sectionJs = function(){
      var $this = this;
      if($this.data('section') == "SlideShow") {
        $this.find('.hero-slider').SlideShow();
      }else if($this.data('section') == "TestimonialActive") {
        $this.find('.testimonial-active').TestimonialActive();
      }else if($this.data('section') == "TestimonialLanding") {
        $this.find('.testimonial-active-landing').TestimonialLanding();
      }else if($this.data('section') == "BlackTestimonial") {
        $this.find('.black-testimonial-active-landing').BlackTestimonial();
      }else if($this.data('section') == "SingleSlideMenu") {
        $this.find('.single-slide-menu').SingleSlideMenu();
      }else if($this.data('section') == "FeatureProducts") {
        $this.find('.product-slider-active').FeatureProducts();
      }else if($this.data('section') == "DealOfTheDay") {
        $this.find('.count-down-area').DealOfTheDay();
      }else if($this.data('section') == "BrandSliderActive") {
        $this.find('.brand-active').BrandSliderActive();
      }else if($this.data('section') == "SliderWithDealCar") {
        $this.find('.product-offer-active').SliderWithDealCar();
      }else if($this.data('section') == "HomeBlogs") {
        $this.find('.blog-slider-active').HomeBlogs();
      }else{}   
    }



    /*----------
     Hero Slider Active
------------------------------*/
    $.fn.SlideShow = function() {
      var $SlideShowVAR = this;
      $SlideShowVAR.owlCarousel({

        smartSpeed: 1000,
        nav: true,
        
        loop: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplay: false,
        navText: ['prev', 'next'],
        responsive: {
          0: {
            items: 1,
            autoplay: true
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      });
    };
    
    /*----------
     Testimonial Active
------------------------------*/
    $.fn.TestimonialActive = function() {
      var $TestimonialActiveVar = this;
      $TestimonialActiveVar.owlCarousel({
        nav: true,
        
        loop: true,
        navText: ['prev', 'next'],
        responsive: {
          0: {
            items: 1,
            autoplay: true
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      });
    };


    $.fn.TestimonialLanding = function() {
      var $TestimonialLandingVar = this;
      $TestimonialLandingVar.owlCarousel({
        nav: true,
        
        loop: true,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        responsive: {
          0: {
            items: 1,
            autoplay: true
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      });
    };

    
    $.fn.BlackTestimonial = function() {
      var $BlackTestimonialVar = this;
      $BlackTestimonialVar.owlCarousel({
        nav: true,
        
        loop: true,
        nav:false,
        margin:30,
        responsive: {
          0: {
            items: 1,
            autoplay: true
          },
          600: {
            items: 1
          },
          1000: {
            items: 2
          }
        }
      });
    };



/*------- 
     Single Slide Menu Active 
----------------------------------*/
    $.fn.SingleSlideMenu = function() {
      var $SingleSlideMenuVar = this;
      $SingleSlideMenuVar.owlCarousel({
        smartSpeed: 1000,
        nav: false,
        
        responsive: {
          0: {
            items: 3
          },
          450: {
            items: 3
          },
          768: {
            items: 4
          },
          1000: {
            items: 4
          },
          1200: {
            items: 4
          }
        }
      });
    };
    
    
    

 
    


    /*----------
    Product Slider Active
------------------------------*/
    $.fn.FeatureProducts = function() {
      var $FeatureProductsVAR = this;
      $FeatureProductsVAR.slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        dots: true,
        rows:2,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    };

    
/*----------
    Blog Slider Active
------------------------------*/
    
        $.fn.HomeBlogs = function() {
      var $HomeBlogsVAR = this;
      $HomeBlogsVAR.slick({
        

		slidesToShow: 3,
		arrows: false,
        dots: true,
        infinite: false,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
       }); 
        };   

    
    
    
    
$('.modal').on('shown.bs.modal', function (e) {
    $('.single-slide-menu').resize();
})
    
$('.single-slide-menu a').on('click',function(e){
  e.preventDefault();

  var $href = $(this).attr('href');

  $('.single-slide-menu a').removeClass('active');
  $(this).addClass('active');

  $('.product-details-large .tab-pane').removeClass('active show');
  $('.product-details-large '+ $href ).addClass('active show');

})
/*------- 
    Blog Gallery Post Active 
----------------------------------*/
$('.post-gallery').owlCarousel({
  nav: true,
  
  autoplay: true,
  autoplayTimeout: 5000,
  navText: ['<i class="fa fa-caret-left"></i>', '<i class="fa fa-caret-right"></i>'],
  responsive: {
    0: {
      items: 1
    },
    450: {
      items: 1
    },
    768: {
      items: 1
    },
    1000: {
      items: 1
    },
    1200: {
      items: 1
    }
  }
})
/*----------------------------
    ** Slick Slider Active **
------------------------------ */


    
    /*----------
    Brand Slider Active
------------------------------*/
    $.fn.BrandSliderActive = function() {
      var $BrandSliderActiveVAR = this;
      $BrandSliderActiveVAR.slick({  
      slidesToShow: 5,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    }); 
    
    };




/*----------
    Store Slider Active
------------------------------*/
$('.store-slider-active').slick({
  slidesToShow: 3,
  arrows: false,
  
  dots: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});
    
    
    /*----------
    Product Offer Active
------------------------------*/
    
    $.fn.SliderWithDealCar = function() {
      var $SliderWithDealCarVAR = this;
      $SliderWithDealCarVAR.slick({  

        slidesToShow: 1,
        arrows: false,
        dots: true,
        
        infinite: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    };
    
/*----------
    Sidebar Product Active
------------------------------*/
$('.sidebar-product-active').slick({
		slidesToShow: 1,
		arrows: false,
        dots: true,
        
        infinite: false,
        responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
});

/*----------
    Product List Slider Active
------------------------------*/
$('.product-list-slider-active').slick({
		slidesToShow: 3,
		arrows: false,
        dots: true,
        
        infinite: false,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
});
/*----------
    Product List Slider Active 2
------------------------------*/
$('.product-list-slider-active2').slick({
		slidesToShow: 2,
		arrows: false,
        dots: true,
        
        infinite: false,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
});
/*----------
     Hot Deal Slider Active
------------------------------*/
    
    $.fn.DealOfTheDay = function() {
      var $DealOfTheDayVAR = this;
      $DealOfTheDayVAR.slick({   
        slidesToShow: 1,
        slidesToScroll: 3,
        arrows: false,
        fade: true,
        asNavFor: '.offer-slider'
      });
      $('.offer-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        asNavFor: '.count-down-area',
        dots: true,
        centerMode: true,
        arrows: false,
        infinite: true,
        centerPadding: '0px',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      }); 
    };
  
/*----------------------------------- 
    Single Product Slide Menu Active 
--------------------------------------*/  
$('.product-tab-thumbs-new').slick({
		prevArrow: '<i class="fa fa-angle-left"></i>',
		nextArrow: '<i class="fa fa-angle-right slick-next-btn"></i>',
        slidesToShow: 4,
        
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
          ]
	});   
$('.product-tab-thumbs a').on('click',function(e){
      e.preventDefault();
     
      var $href = $(this).attr('href');
     
      $('.product-tab-thumbs a').removeClass('active');
      $(this).addClass('active');
     
      $('.single-product-img .tab-pane').removeClass('active show');
      $('.single-product-img '+ $href ).addClass('active show');
     
  })  
/*----------------------------------
    ScrollUp Active
-----------------------------------*/
$.scrollUp({
    scrollText: '<i class="fa fa-angle-up"></i>',
    easingType: 'linear',
    scrollSpeed: 900,
    animation: 'fade'
});    
/*---------------------------------
     Sticky Menu Active
-----------------------------------*/
$(window).on('scroll', function() {
if ($(this).scrollTop() >50){  
    $('.header-sticky').addClass("is-sticky");
  }
  else{
    $('.header-sticky').removeClass("is-sticky");
  }
});     
/*--------------------------
	 Category Menu Active
---------------------------- */
 $('.rx-parent').on('click', function(){
    $('.rx-child').slideToggle();
    $(this).toggleClass('rx-change');
});
//    category heading
$('.category-heading').on('click', function(){
    $('.category-menu-list').slideToggle(300);
});	

/*-- Category Menu Toggles --*/
function categorySubMenuToggle() {
    var screenSize = $(window).width();
    if ( screenSize <= 991) {
        $('#cate-toggle .right-menu > a').prepend('<i class="expand menu-expand"></i>');
        $('.category-menu .right-menu ul').slideUp();
//        $('.category-menu .menu-item-has-children i').on('click', function(e){
//            e.preventDefault();
//            $(this).toggleClass('expand');
//            $(this).siblings('ul').css('transition', 'none').slideToggle();
//        })
    } else {
        $('.category-menu .right-menu > a i').remove();
        $('.category-menu .right-menu ul').slideDown();
    }
}
categorySubMenuToggle();
$(window).resize(categorySubMenuToggle);

/*-- Category Sub Menu --*/
$('.category-menu-list').on('click', 'li a, li a .menu-expand', function(e) {
    var $a = $(this).hasClass('menu-expand') ? $(this).parent() : $(this);
    if ($a.parent().hasClass('right-menu')) {
        if ($a.attr('href') === '#' || $(this).hasClass('menu-expand')) {
            if ($a.siblings('ul:visible').length > 0) $a.siblings('ul').slideUp();
            else {
                $(this).parents('li').siblings('li').find('ul:visible').slideUp();
                $a.siblings('ul').slideDown();
            }
        }
    }
    if ($(this).hasClass('menu-expand') || $a.attr('href') === '#') {
        e.preventDefault();
        return false;
    }
});
/*--------------------------------
    Price Slider Active
-------------------------------- */
var sliderrange = $('#slider-range');
var amountprice = $('#amount');
$(function() {
    sliderrange.slider({
        range: true,
        min: 20,
        max: 100,
        values: [0, 100],
        slide: function(event, ui) {
            amountprice.val("$" + ui.values[0] + " - $" + ui.values[1]);
        }
    });
    amountprice.val("$" + sliderrange.slider("values", 0) +
        " - $" + sliderrange.slider("values", 1));
});
/*------------------------------ 
    Nice Select Active
---------------------------------*/
$('select.nice-select').niceSelect();
    
/*------------------------------ 
    Toggle Function Active
---------------------------------*/   
/*--- showlogin toggle function ----*/
    $('#showlogin').on('click', function() {
        $('#checkout-login').slideToggle(900);
    });

 /*--- showlogin toggle function ----*/
    $('#showcoupon').on('click', function() {
        $('#checkout_coupon').slideToggle(900);
    });
/*--- showlogin toggle function ----*/
    $('#cbox').on('click', function() {
        $('#cbox-info').slideToggle(900);
    });

 /*--- showlogin toggle function ----*/
    $('#ship-box').on('click', function() {
        $('#ship-box-info').slideToggle(1000);
    });
/* --------------------------------------------------------
    FAQ Accordion Active
* -------------------------------------------------------*/ 
  $('.card-header a').on('click', function() {
    $('.card').removeClass('actives');
    $(this).parents('.card').addClass('actives');
  });
/*--------------------------
    Isotope Active
---------------------------- */
$('.protfolio-active').imagesLoaded( function() {
// images have loaded
    // init Isotope
    var $grid = $('.protfolio-active').isotope({
      // options
    });
    // filter items on button click
    $('.protfolio-menu-active').on( 'click', 'li', function() {
      var filterValue = $(this).attr('data-filter');
      $grid.isotope({ filter: filterValue });

          $(this).siblings('.active').removeClass('active');
          $(this).addClass('active');
          event.preventDefault();
    });
});  
/* --------------------------------------------------------
    Venobox Active
* -------------------------------------------------------*/  
  $('.venobox').venobox({
        border: '10px',
        titleattr: 'data-title',
        numeratio: true,
        infinigall: true
});});
  

  
})(jQuery);





$(document).ready(function(){
  $(".row.testimonial-active").owlCarousel({
    items: 1, // Adjust the number of items you want to display
    loop: true,
    autoplay: true,
    smartSpeed: 3000,
    autoplayTimeout: 3000, // 3 seconds
    autoplayHoverPause: true, // Optional: pause on hover
    nav: true,
    dot: true,
  });

  $(".black-testimonial-active-landing").owlCarousel({
    items: 2, // Adjust the number of items you want to display
    loop: true,
    autoplay: true,
    autoplayTimeout: 6000, // 3 seconds
    smartSpeed: 3000,
    autoplayHoverPause: false, // Optional: pause on hover
    dot: true,
    responsive:{
        0:{
            items:1,
        },
        991:{
            items:2,
        }
    },
    onInitialized: function(event) {
      // Calculate the width of each .owl-item and set the margin-right
      $('.owl-item').each(function() {
        var itemWidth = $(this).width() - 30; // Subtract the margin-right
        $(this).css({
          'width': itemWidth + 'px',
          'margin-right': '30px'
        });
      });
    }
  });
});